import { Outlet, useNavigate } from 'react-router-dom';

import { useAuthStore } from '@features/auth/stores/useAuthStore';
import { isAuthSatisfied } from '@features/auth/utils/isAuthSatisfied';
import AuthModal from '@features/auth/components/AuthModal';

import { ROUTE_PATHS } from '@router/paths';
import { RouteName } from '@router/routeNames';

interface Props {
  allowGuest?: boolean;
}

export default function AuthGuard({ allowGuest }: Props) {
  const navigate = useNavigate();
  const satisfied = useAuthStore((state) => isAuthSatisfied(state, { allowGuest }));

  const handleDismissal = () => navigate(ROUTE_PATHS[RouteName.MAP]);

  return <>{satisfied ? <Outlet /> : <AuthModal onOpenChange={handleDismissal} allowGuest={allowGuest} />}</>;
}
